export enum DataTypeEnum {
   MOG = 'MOG',
   ROG = 'ROG'
}